import { PAGE_RECEIPTS } from '../actionTypes';

export const fetchPageReceipts = (action) => ({
  type: PAGE_RECEIPTS.FETCH,
  payload: action.payload,
});
